import { SCHEDULE_TYPES } from '@src/constants/commons';

export const BASE_URL = 'operational-panel';

export const PATHS = {
  BASE_URL,
};

/** Interactive zoom limits and the independent initial/reset framing cap. */
export const EXECUTION_HEX_ZOOM = {
  minScale: 0.4,
  maxScale: 5,
  maxFitScale: 2.5,
  minFitScaleRatio: 0.7,
} as const;

/** Attendance KPI refresh cadence (Elasticsearch fetch, not a live listener). */
export const ATTENDANCE_KPI_REFRESH_MS = 120_000;

/** Schedule kinds the honeycomb groups by. Adding a type is this list plus a label id. */
export const EXECUTION_HEX_GROUP_ORDER = [
  SCHEDULE_TYPES.schedule,
  SCHEDULE_TYPES.checkpoint_route,
  SCHEDULE_TYPES.task,
] as const;

/** Cluster id used when an execution carries no division; not a real division id. */
export const UNKNOWN_DIVISION_GROUP_ID = 'unknown-division';

/** Tooltip overlay class for card-style execution hex tooltips (see SemanticZoomHexGrid). */
export const HEX_TOOLTIP_CARD_OVERLAY_CLASS = 'hexTooltipCard';

export const EXECUTION_HEX_GROUP_LABEL_IDS: Record<string, string> = {
  [SCHEDULE_TYPES.schedule]: 'schedules.type.schedule',
  [SCHEDULE_TYPES.checkpoint_route]: 'schedules.type.checkpoint_route',
  [SCHEDULE_TYPES.task]: 'schedules.type.task',
};
